/** Helpers for host-chat verification system messages. */

export const isSystemMessage = (msg) =>
  String(msg?.messageType || "").toLowerCase() === "system";

export const isVerificationRequestedMessage = (msg) =>
  isSystemMessage(msg) &&
  /verification\s+requested/i.test(String(msg?.text || ""));

export const isIdentityVerifiedMessage = (msg) =>
  isSystemMessage(msg) &&
  /identity\s+verified/i.test(String(msg?.text || ""));

export const isVerificationRevokedMessage = (msg) =>
  isSystemMessage(msg) &&
  /verification\s+revoked/i.test(String(msg?.text || ""));

/**
 * Latest verification status for the sticky chat banner.
 * Prefers the most recent verification-related system message.
 * A revoke clears the verified/pending banners so they cannot linger.
 */
export const getVerificationBannerState = (messages = []) => {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const msg = messages[i];
    if (isVerificationRevokedMessage(msg)) {
      return {
        type: "revoked",
        note: msg.note || null,
      };
    }
    if (isIdentityVerifiedMessage(msg)) {
      return {
        type: "verified",
        note: msg.note || null,
        unitName: msg.raw?.unitName || msg.raw?.unitDetails?.unitName || null,
      };
    }
    if (isVerificationRequestedMessage(msg)) {
      return { type: "pending" };
    }
  }
  return null;
};
